import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

  private readonly key = environment.keyCrypt;

  addItem(key: string, value: string): void {
    localStorage.setItem(key, this.encrypt(value));
  }

  getItem(key: string): string {
    return this.decrypt(localStorage.getItem(key) ?? '');
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clearStorage(): void {
    localStorage.clear();
  }

  private encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.key).toString();
  }

  private decrypt(value: string): string {
    if (!value) return '';
    try {
      return CryptoJS.AES.decrypt(value, this.key).toString(CryptoJS.enc.Utf8);
    } catch {
      return '';
    }
  }
}
